import { HeaderLayoutLeftButton } from "@components/page-layout/header/header-layout-left-button";
import { MainPageLayout } from "@components/page-layout/main-page-layout";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useShouldShowAddCredits } from "@hooks/use-should-show-add-credits";
import { Box } from "@mui/material";
import { ForbiddenPage } from "@pages/forbidden-page";
import { CreditPackages } from "@pages/settings/subscription-settings/credits/credit-packages";
import { SettingsTabs } from "@router/route-params";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useState } from "react";
import { CloseIcon } from "@flat-ui";

/** Renders a page with list of credit packages available for purchase */
export function AddCreditsPage(): JSX.Element {
  const { navigateToSettingsPage } = useAppNavigation();
  const companyId = useCompanyId();
  const { shouldShowAddCredits } = useShouldShowAddCredits();

  const [selectedPackage, setSelectedPackage] = useState<
    FaroCoreApiTypes.StripeProduct | undefined
  >(undefined);

  if (!shouldShowAddCredits) {
    return <ForbiddenPage />;
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <MainPageLayout
        shouldHideOpenButton={true}
        shouldShowSidebar={false}
        shouldShowTopbarBorder={true}
        topLeftHeaderButton={
          <HeaderLayoutLeftButton
            tooltip={`Close ${CREDITS_DISPLAY_NAME} page`}
            icon={CloseIcon}
            text="Close"
            onClickHandler={() =>
              navigateToSettingsPage({
                companyId,
                settingsTab: SettingsTabs.subscription,
              })
            }
          />
        }
        shouldUseFullBodyLayout={true}
      >
        <CreditPackages
          selectedPackage={selectedPackage}
          setSelectedPackage={setSelectedPackage}
        />
      </MainPageLayout>
    </Box>
  );
}
